import { Button, Modal, typography } from '@ui';
import { useTranslate } from '@i18n';

type ShareConfirmationModalProps = {
    open: boolean;
    onDismiss: () => void;
    onConfirm: () => void;
};

export default function ShareConfirmationModal({ open, onDismiss, onConfirm }: ShareConfirmationModalProps) {
    const t = useTranslate();
    return (
        <Modal
            variant="partial"
            title={t('user_settings.sharing_title')}
            open={open}
            onDismiss={onDismiss}
            footer={{
                primary: (
                    <Button variant="primary" onClick={onConfirm}>
                        {t('user_settings.share_data')}
                    </Button>
                ),
                secondary: (
                    <Button variant="secondary" onClick={onDismiss}>
                        {t('generic_ui.cancel')}
                    </Button>
                ),
            }}
        >
            <p className={typography({ variant: 'p' })} style={{ maxWidth: 600 }}>
                {t('user_settings.sharing_message')}
            </p>
        </Modal>
    );
}
